<template>
    <div>
        <div class="subscription-selector" v-if="initialized">

            <div v-if="subscriptionIsCanceled">
                {{ window.t('subscription_cancelled') }}<br>
                <br>
            </div>
            <ul class="groups">
                <li v-for="(group, groupIndex) in groups" :key="'group-' + groupIndex" :class="['btn w150', {secondary: groupIndex != selectedGroup, current: group.type == currentGroupType}]" @click.prevent="selectGroup(groupIndex)">{{ group.name }}<template v-if="group.type == currentGroupType"> ({{ window.t('subscription_current') }})</template></li>
            </ul>

            <div class="description" v-if="groups[selectedGroup].description">
                <div v-html="groups[selectedGroup].description"></div>
                <a v-if="termsLinkTitle" href="#legal" class="terms">{{ termsLinkTitle }}</a>
                <template v-if="groups[selectedGroup].type == 'corporate' && contactPageUrl && quoteButtonTitle">
                    <br>
                    <br>
                    <br>
                    <a :href="contactPageUrl" class="btn current">{{ quoteButtonTitle }}</a>
                </template>
            </div>

            <div v-if="groups[selectedGroup].options" :key="'group-content-' + selectedGroup" class="options">
                <div v-for="(option, optionIndex) in groups[selectedGroup].options" :key="'group-content-' + selectedGroup + '-option-' + optionIndex" :class="['option', {on: option.selected, current: option.type == currentOptionType && groups[selectedGroup].type == currentGroupType}]" @click.prevent="selectOption(optionIndex)">

                    <div class="bg"></div>
                    <div v-if="option.type == currentOptionType && groups[selectedGroup].type == currentGroupType" class="current">{{ window.t('subscription_current') }}</div>
                    <div v-else-if="option.popular" class="popular">{{ window.t('subscription_populair') }}</div>
                    <div class="quantity">{{ option.credits }}</div>
                    <div class="details">
                        {{ option.credits }} {{ window.t('subscription_credits', true) }} / {{ window.t('subscription_month', true) }}<br>
                        &euro;{{ formatPrice(option.price) }} / {{ window.t('subscription_month', true) }}<br>
                        {{ window.t('subscription_vat') }}
                    </div>
                </div>
            </div>
            <template v-if="groups[selectedGroup].type != 'corporate'">
                <br>
                <a v-if="!loggedIn" href="#" @click.prevent="toggleRegister" class="btn w150">{{ window.t('subscription_continue_btn') }}</a>
                <template v-else-if="!buttonsDisabled">
                    <template v-if="subscriptionIsPausedUntil">
                        {{ window.t('subscription_paused_until', false, {'pausedUntil': subscriptionIsPausedUntil}) }}<br><br>
                        <a href="#" @click.prevent="toggleCancelSubscription" :class="['btn', 'secondary']">{{ window.t('cancel_my_subscription') }}</a>
                        <a href="#" @click.prevent="toggleActivateSubscription" :class="['btn']">{{ window.t('reactivate_my_subscription') }}</a>
                    </template>
                    <div class="change-subscription-box" v-else>
                        <a href="#" v-if="!subscriptionIsCanceled" @click.prevent="toggleCancelSubscription" :class="['btn', 'secondary']">{{ window.t('cancel_my_subscription') }}</a>
                        <a href="#" v-if="!subscriptionIsCanceled" @click.prevent="toggleChangePaymentMethod" :class="['btn', 'secondary']">{{ window.t('change_payment_method') }}</a>
                        <template v-if="subscriptionIsCanceled">
                            <span></span>
                            <a href="#" @click.prevent="toggleReactivateSubscription" :class="['btn', 'secondary']">{{ window.t('subscription_reinstate') }}</a>
                        </template>
                        <template v-else-if="canChangeSubscription">
                            <a href="#" v-if="canPauseSubscription" @click.prevent="togglePauseSubscription" :class="['btn', 'secondary']">{{ window.t('pause_my_subscription') }}</a>
                            <a href="#" @click.prevent="toggleChangeSubscription" :class="['btn', 'secondary', {disabled: isCurrentSubscription}]">{{ window.t('subscription_change') }}</a>
                        </template>
                    </div>
                    <span v-if="!subscriptionIsPausedUntil && !canChangeSubscription && !subscriptionChanged && !subscriptionIsCanceled"><br>{{ window.t('subscription_recently_changed', false, {'canChangeSubscriptionDate': canChangeSubscriptionDate}) }}</span>

                </template>
            </template>
        </div>
        <section class="modal checkout" v-if="registerVisible && !loggedIn">
			<div class="bg" @click.prevent="toggleRegister"></div>
            <div class="panel-scroller">
    			<div class="panel">
    				<a href="#" class="close" @click.prevent="toggleRegister"></a>
    				<form class="form">
    					<div class="modal-head">
    						<h2 class="h2">{{ window.t('subscription_register') }}</h2>
    						<h3 class="h2 black">{{ selectedSubscriptionName }}</h3>
    						<div class="txt">
                                &euro;{{ formatPrice(selectedSubscriptionOptionPrice) }} / {{ window.t('subscription_month', true) }} (excl. &euro;{{ formatPrice(selectedSubscriptionOptionVat)}} VAT)<br>
                                {{ selectedSubscriptionOptionCredits }} {{ window.t('subscription_credits', true) }} / {{ window.t('subscription_month', true) }}<br>
                            </div>
    					</div>
    					<div class="modal-body">
    						<div class="step">
    							<div class="fields">
                                    <div class="field w50">
                                        <input type="text" name="first_name" id="first_name" :placeholder="window.t('form_first_name')+'*'" v-model="registerData.first_name">
                                        <span class="incorrect" v-if="errors.first_name" v-html="showError('first_name')"></span>
                                    </div>
                                    <div class="field w50">
                                        <input type="text" name="last_name" id="last_name" :placeholder="window.t('form_last_name')+'*'" v-model="registerData.last_name">
                                        <span class="incorrect" v-if="errors.last_name" v-html="showError('last_name')"></span>
                                    </div>

                                    <div class="field w50">
                                        <input type="email" name="email" id="email" :placeholder="window.t('form_email')+'*'" v-model="registerData.email">
                                        <span class="incorrect" v-if="errors.email" v-html="showError('email')"></span>
                                    </div>
                                    <div class="field w50">
                                        <input type="text" name="phone" id="phone" :placeholder="window.t('form_phone')+'*'" v-model="registerData.phone">
                                        <span class="incorrect" v-if="errors.phone" v-html="showError('phone')"></span>
                                    </div>
                                    <div class="field w50">
                                        <input type="text" name="postalcode" id="postalcode" :placeholder="window.t('form_zipcode')+'*'" v-model="registerData.postalcode">
                                        <span class="incorrect" v-if="errors.postalcode" v-html="showError('postalcode')"></span>
                                    </div>
                                    <div class="field w50">
                                        <select v-model="registerData.country">
                                            <option v-for="country in countries" :key="'country-select-' + country.code" :value="country.code">{{ country.name }}</option>
                                        </select>
                                        <span class="incorrect" v-if="errors.country" v-html="showError('country')"></span>
                                    </div>
                                    <div class="field w50">
                                        <input type="text" name="state" id="state" :placeholder="window.t('form_state')" v-model="registerData.state">
                                        <span class="incorrect" v-if="errors.state" v-html="showError('state')"></span>
                                    </div>
                                    <div class="field w50">
                                        <input type="text" name="city" id="city" :placeholder="window.t('form_city')" v-model="registerData.city">
                                        <span class="incorrect" v-if="errors.city" v-html="showError('city')"></span>
                                    </div>
                                    <div class="field w100">
                                        <input type="text" name="address1" id="address1" :placeholder="window.t('form_address_1')" v-model="registerData.address1">
                                        <span class="incorrect" v-if="errors.address1" v-html="showError('address1')"></span>
                                    </div>
                                    <div class="field w100">
                                        <input type="text" name="address2" id="address2" :placeholder="window.t('form_address_2')" v-model="registerData.address2">
                                        <span class="incorrect" v-if="errors.address2" v-html="showError('address2')"></span>
                                    </div>
                                    <div class="field w50">
                                        <input type="text" name="company" id="company" :placeholder="window.t('form_company')" v-model="registerData.company">
                                        <span class="incorrect" v-if="errors.company" v-html="showError('company')"></span>
                                    </div>
                                    <div class="field w50">
                                        <input type="text" name="vat_number" id="vat_number" :placeholder="window.t('form_vat')" v-model="registerData.vat_number">
                                        <span class="incorrect" v-if="errors.vat_number" v-html="showError('vat_number')"></span>
                                    </div>
                                    <div class="field w50">
                                        <input type="password" name="password" id="password" :placeholder="window.t('form_password')+'*'" v-model="registerData.password">
                                        <span class="incorrect" v-if="errors.password" v-html="showError('password')"></span>
                                    </div>
                                    <div class="field w50">
                                        <input type="password" name="password_confirmation" id="password_confirmation" :placeholder="window.t('form_password_confirmation')+'*'" v-model="registerData.password_confirmation">
                                        <span class="incorrect" v-if="errors.password_confirmation" v-html="showError('password_confirmation')"></span>
                                    </div>
                                </div>
    						</div>
    					</div>
    					<div class="modal-foot">
                            <div>&nbsp;</div>
    						<a href="#" :class="['btn', 'w180']" @click.prevent="register">{{ window.t('subscription_complete_registration') }}</a>
    					</div>
    				</form>
    			</div>
            </div>
		</section>
        <section class="modal checkout" v-if="changeSubscriptionVisible && loggedIn">
			<div class="bg" @click.prevent="toggleChangeSubscription"></div>
            <div class="panel-scroller">
    			<div class="panel">
    				<a href="#" class="close" @click.prevent="toggleChangeSubscription"></a>
    				<!-- <form class="form"> -->
    					<div class="modal-head">
    						<h2 class="h2">{{ window.t('subscription_register') }}</h2>
    						<h3 class="h2 black">{{ selectedSubscriptionName }}</h3>
    						<div class="txt">
                                &euro;{{ formatPrice(selectedSubscriptionOptionPrice) }} / {{ window.t('subscription_month', true) }}<br>
                                {{ selectedSubscriptionOptionCredits }} {{ window.t('subscription_credits', true) }} / {{ window.t('subscription_month', true) }}<br>
                            </div>
    					</div>
    					<div class="modal-body">
    						<div class="step">
                                <template v-if="groups[currentGroupIndex].options[currentOptionIndex].price < selectedSubscriptionOptionPrice">
                                    {{ window.t('subscription_upgrade_confirm') }}
                                </template>
                                <template v-else-if="groups[currentGroupIndex].options[currentOptionIndex].price == selectedSubscriptionOptionPrice">
                                    {{ window.t('subscription_change_confirm') }}
                                </template>
                                <template v-else>
                                    {{ window.t('subscription_downgrade_confirm') }}
                                </template>
                                <div><br>{{ window.t('subscription_already_changed') }}</div>
                            </div>
                        </div>
    					<div class="modal-foot">
    						<a href="#" :class="['btn', 'secondary', 'w180']" @click.prevent="toggleChangeSubscription">{{ window.t('subscription_no_thanks_btn') }}</a>
                            <div>&nbsp;</div>
    						<a href="#" :class="['btn', 'w180']" @click.prevent="changeSubscription">{{ window.t('subscription_confirm_btn') }}</a>
    					</div>
                    <!-- </form> -->
                </div>
            </div>
        </section>
        <section class="modal checkout" v-if="reactivateSubscriptionVisible && loggedIn">
			<div class="bg" @click.prevent="toggleReactivateSubscription"></div>
            <div class="panel-scroller">
    			<div class="panel">
    				<a href="#" class="close" @click.prevent="toggleReactivateSubscription"></a>
    				<!-- <form class="form"> -->
    					<div class="modal-head">
    						<h2 class="h2">{{ window.t('subscription_register') }}</h2>
    						<h3 class="h2 black">{{ selectedSubscriptionName }}</h3>
    						<div class="txt">
                                &euro;{{ formatPrice(selectedSubscriptionOptionPrice) }} / {{ window.t('subscription_month', true) }}<br>
                                {{ selectedSubscriptionOptionCredits }} {{ window.t('subscription_credits', true) }} / {{ window.t('subscription_month', true) }}<br>
                            </div>
    					</div>
    					<div class="modal-body">
    						<div class="step">
                                {{ window.t('subscription_reinstate_confirm') }}
                            </div>
                        </div>
    					<div class="modal-foot">
    						<a href="#" :class="['btn', 'secondary', 'w180']" @click.prevent="toggleReactivateSubscription">{{ window.t('subscription_no_thanks_btn') }}</a>
                            <div>&nbsp;</div>
    						<a href="#" :class="['btn', 'w180']" @click.prevent="reactivateSubscription">{{ window.t('subscription_confirm_btn') }}</a>
    					</div>
                    <!-- </form> -->
                </div>
            </div>
        </section>
        <section class="modal checkout" v-if="pauseSubscriptionVisible && loggedIn">
			<div class="bg" @click.prevent="togglePauseSubscription"></div>
            <div class="panel-scroller">
    			<div class="panel">
    				<a href="#" class="close" @click.prevent="togglePauseSubscription"></a>
    				<!-- <form class="form"> -->
    					<div class="modal-head">
    						<h2 class="h2">{{ window.t('subscription_pause') }}</h2>
    					</div>
    					<div class="modal-body">
    						<div class="step">
                                <div v-html="window.t('subscription_pause_confirm')">
                                </div>
                            </div>
                        </div>
    					<div class="modal-foot">
    						<a href="#" :class="['btn', 'secondary', 'w180']" @click.prevent="togglePauseSubscription">{{ window.t('subscription_no_thanks_btn') }}</a>
                            <div>&nbsp;</div>
    						<a href="#" :class="['btn', 'w180']" @click.prevent="pauseSubscription">{{ window.t('subscription_confirm_btn') }}</a>
    					</div>
                    <!-- </form> -->
                </div>
            </div>
        </section>
        <section class="modal checkout" v-if="activateSubscriptionVisible && loggedIn">
			<div class="bg" @click.prevent="toggleActivateSubscription"></div>
            <div class="panel-scroller">
    			<div class="panel">
    				<a href="#" class="close" @click.prevent="toggleActivateSubscription"></a>
    				<!-- <form class="form"> -->
    					<div class="modal-head">
    						<h2 class="h2">{{ window.t('subscription_reactivate') }}</h2>
    					</div>
    					<div class="modal-body">
    						<div class="step">
                                <div v-html="window.t('subscription_reactivate_confirm')">
                                </div>
                            </div>
                        </div>
    					<div class="modal-foot">
    						<a href="#" :class="['btn', 'secondary', 'w180']" @click.prevent="toggleActivateSubscription">{{ window.t('subscription_no_thanks_btn') }}</a>
                            <div>&nbsp;</div>
    						<a href="#" :class="['btn', 'w180']" @click.prevent="activateSubscription">{{ window.t('subscription_confirm_btn') }}</a>
    					</div>
                    <!-- </form> -->
                </div>
            </div>
        </section>
        <section class="modal checkout" v-if="cancelSubscriptionVisible && loggedIn">
			<div class="bg" @click.prevent="toggleCancelSubscription"></div>
            <div class="panel-scroller">
    			<div class="panel">
    				<a href="#" class="close" @click.prevent="toggleCancelSubscription"></a>
    				<!-- <form class="form"> -->
    					<div class="modal-head">
    						<h2 class="h2">{{ window.t('subscription_cancel') }}</h2>
    					</div>
    					<div class="modal-body">
    						<div class="step">
                                <div v-html="window.t('subscription_cancel_confirm')">
                                </div>
                            </div>
                        </div>
    					<div class="modal-foot">
    						<a href="#" :class="['btn', 'secondary', 'w180']" @click.prevent="toggleCancelSubscription">{{ window.t('subscription_no_thanks_btn') }}</a>
                            <div>&nbsp;</div>
    						<a href="#" :class="['btn', 'w180']" @click.prevent="cancelSubscription">{{ window.t('cancel_my_subscription') }}</a>
    					</div>
                    <!-- </form> -->
                </div>
            </div>
        </section>
        <section class="modal checkout" v-if="changePaymentMethodVisible && loggedIn">
			<div class="bg" @click.prevent="toggleChangePaymentMethod"></div>
            <div class="panel-scroller">
    			<div class="panel">
    				<a href="#" class="close" @click.prevent="toggleChangePaymentMethod"></a>
    				<!-- <form class="form"> -->
    					<div class="modal-head">
    						<h2 class="h2">{{ window.t('payment_method_change') }}</h2>
    					</div>
    					<div class="modal-body">
    						<div class="step">
                                <div v-html="window.t('payment_method_change_confirm')">
                                </div>
                            </div>
                        </div>
    					<div class="modal-foot">
    						<a href="#" :class="['btn', 'secondary', 'w180']" @click.prevent="toggleChangePaymentMethod">{{ window.t('subscription_no_thanks_btn') }}</a>
                            <div>&nbsp;</div>
    						<a href="#" :class="['btn', 'w180']" @click.prevent="changePaymentMethod">{{ window.t('change_payment_method') }}</a>
    					</div>
                    <!-- </form> -->
                </div>
            </div>
        </section>

    </div>
</template>


<script>
    export default {
        props: {
            group: {
                type: String,
                defautl: null,
            },
            option: {
                type: String,
                defautl: null,
            },
            currentGroup: {
                type: String,
                defautl: null,
            },
            currentOption: {
                type: String,
                defautl: null,
            },
            locale: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                window,
                initialized: false,
                buttonsDisabled: false,
                visible: false,
                selectedGroup: 0,
                currentGroupIndex: null,
                currentGroupType: null,
                currentOptionIndex: null,
                currentOptionType: null,
                subscriptionIsCanceled: false,
                groups: [],
                termsLinkTitle: '',
                quoteButtonTitle: '',
                loggedIn: false,
                registerVisible: false,
                changeSubscriptionVisible: false,
                reactivateSubscriptionVisible: false,
                pauseSubscriptionVisible: false,
                activateSubscriptionVisible: false,
                cancelSubscriptionVisible: false,
                changePaymentMethodVisible: false,
                canChangeSubscription: false,
                canChangeSubscriptionDate: null,
                canPauseSubscription: false,
                subscriptionChanged: false,
                subscriptionIsPausedUntil: null,
                countries: [],
                errors: {},
                registerData: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    state: '',
                    city: '',
                    postalcode: '',
                    country: 'nl',
                    address1: '',
                    address2: '',
                    company: '',
                    vat_number: '',
                    password: '',
                    password_confirmation: '',
                },
                contactPageUrl: null,
            }
        },
        watch: {

        },
        methods: {
            updateCredits(delay = 0) {
                setTimeout(() => {
                    axios.post('/subscription/credits')
                        .then((response) => {
                            if (response.data.hasOwnProperty('credits')) {
                                this.$root.$emit('updateCredits', response.data.credits);
                            }
                        });
                }, delay);

            },
            changeSubscription() {
                if (!this.groups[this.currentGroupIndex] || !this.groups[this.currentGroupIndex].options[this.currentOptionIndex]) {
                    alert('Something went wrong. Please contact us.');
                    return false;
                }

                const postData = {
                    subscription_type: this.groups[this.selectedGroup].type,
                    subscription_option: this.selectedSubscriptionOptionType,
                };

                axios.post('/subscription/change', postData)
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) {
                            this.canChangeSubscription = false;
                            this.subscriptionChanged = true;
                            this.currentGroupType = this.groups[this.selectedGroup].type;
                            this.currentGroupIndex = this.selectedGroup;
                            this.currentOptionType = this.selectedSubscriptionOptionType;
                            this.currentOptionIndex = this.selectedSubscriptionOptionIndex;

                            this.$emit('group', this.currentGroupType);
                            this.$emit('option', this.currentOptionType);

                            this.changeSubscriptionVisible = false;
                            alert('Your subscription has been updated.')
                        } else {
                            alert('There was an error updating your subscription. Please contact us.');
                        }

                        this.updateCredits(200);
                    })
                    .catch((error) => {
                        if (error.response.hasOwnProperty('data')) {
                            alert(error.response.data.errors.subscription_option[0]);
                        }
                    });

            },
            reactivateSubscription() {
                if (!this.groups[this.currentGroupIndex] || !this.groups[this.currentGroupIndex].options[this.currentOptionIndex]) {
                    alert('Something went wrong. Please contact us.');
                    return false;
                }

                const postData = {
                    subscription_type: this.groups[this.selectedGroup].type,
                    subscription_option: this.selectedSubscriptionOptionType,
                };

                axios.post('/subscription/reactivate', postData)
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) {
                           document.location = response.data.redirect;
                        } else {
                            alert('There was an error re-instating your subscription. Please contact us.');
                        }

                        // this.updateCredits(200);
                    })
                    .catch((error) => {
                        if (error.response.hasOwnProperty('data')) {
                            alert(error.response.data.errors.subscription_option[0]);
                        }
                    });

            },
            pauseSubscription() {
                axios.post('/subscription/pause')
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) {
                            this.canChangeSubscription = false;
                            this.pauseSubscriptionVisible = false;
                            this.subscriptionIsPausedUntil = response.data.subscriptionIsPausedUntil;
                            this.canPauseSubscription = false;

                            alert('Your subscription has been paused.')
                        } else {
                            alert('There was an error updating your subscription. Please contact us.');
                        }
                    })
                    .catch((error) => {
                        if (error.response.hasOwnProperty('data')) {
                            alert(error.response.data.errors.subscription_option[0]);
                        }
                    });
            },
            activateSubscription() {
                axios.post('/subscription/activate')
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) {
                            this.canChangeSubscription = response.data.canChangeSubscription;
                            this.canChangeSubscriptionDate = response.data.canChangeSubscriptionDate;
                            this.canPauseSubscription = false;
                            this.subscriptionIsPausedUntil = null;
                            this.activateSubscriptionVisible = false;

                            alert('Your subscription has been activated.')
                        } else {
                            alert('There was an error updating your subscription. Please contact us.');
                        }
                    })
                    .catch((error) => {
                        if (error.response.hasOwnProperty('data')) {
                            alert(error.response.data.errors.subscription_option[0]);
                        }
                    });
            },
            cancelSubscription() {
                axios.post('/subscription/cancel')
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) {
                            this.subscriptionIsCanceled = true;
                            this.cancelSubscriptionVisible = false;

                            alert('Your subscription has been canceled.')
                        } else {
                            alert('There was an error canceling your subscription. Please contact us.');
                        }
                    })
                    .catch((error) => {
                        if (error.response.hasOwnProperty('data')) {
                            alert(error.response.data.errors.subscription_option[0]);
                        }
                    });
            },
            changePaymentMethod() {
                axios.post('/subscription/change-payment-method')
                    .then((response) => {
                        if (response.data.hasOwnProperty('redirect')) {
                            document.location = response.data.redirect;
                        } else {
                            alert('There was an error changing your payment method. Please contact us.');
                        }
                    })
                    .catch((error) => {
                        if (error.response.hasOwnProperty('data')) {
                            alert(error.response.data.errors.subscription_option[0]);
                        }
                    });
            },
            showError(fieldName) {
                if (!this.errors[fieldName]) {
                    return '';
                }

                return this.errors[fieldName].join('<br>');
            },
            toggleChangeSubscription() {
                if (!this.groups[this.currentGroupIndex] || !this.groups[this.currentGroupIndex].options[this.currentOptionIndex]) {
                    this.changeSubscriptionVisible = false;
                } else {
                    if (this.currentGroupIndex == this.selectedGroup && this.currentOptionType == this.selectedSubscriptionOptionType) {
                        this.changeSubscriptionVisible = false;
                    } else {
                        this.changeSubscriptionVisible = !this.changeSubscriptionVisible;
                    }
                }
            },
            toggleReactivateSubscription() {
                if (!this.subscriptionIsCanceled) {
                    this.reactivateSubscriptionVisible = false;
                } else {
                    this.reactivateSubscriptionVisible = !this.reactivateSubscriptionVisible;
                }
            },
            toggleRegister() {
                this.registerVisible = !this.registerVisible;
                $html.toggleClass('modal-visible');
            },
            togglePauseSubscription() {
                this.pauseSubscriptionVisible = !this.pauseSubscriptionVisible;
            },
            toggleActivateSubscription() {
                this.activateSubscriptionVisible = !this.activateSubscriptionVisible;
            },
            toggleCancelSubscription() {
                this.cancelSubscriptionVisible = !this.cancelSubscriptionVisible;
            },
            toggleChangePaymentMethod() {
                this.changePaymentMethodVisible = !this.changePaymentMethodVisible;
            },
            selectGroup(groupIndex) {
                if (this.loggedIn && !this.canChangeSubscription && !this.subscriptionIsCanceled) {
                    return false;
                }

                this.selectedGroup = groupIndex;
            },
            selectOption(optionIndex) {
                if (this.loggedIn && !this.canChangeSubscription && !this.subscriptionIsCanceled) {
                    return false;
                }

                for (let o in this.groups[this.selectedGroup].options) {
                    this.groups[this.selectedGroup].options[o].selected = o == optionIndex;
                }
            },
			formatPrice(amount, decimalCount = 2, decimal = ",", thousands = ".") {
				try {
					decimalCount = Math.abs(decimalCount);
					decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

					const negativeSign = amount < 0 ? "-" : "";

					let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
					let j = (i.length > 3) ? i.length % 3 : 0;

					const returnprice = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");

					return returnprice.replace(',00',',-');
				} catch (e) {

				}
            },
            register() {
                this.errors = {};
                const postData = _.clone(this.registerData);
                postData.subscription_type = this.groups[this.selectedGroup].type;
                postData.subscription_option = this.selectedSubscriptionOptionType;

                axios.post('/register', postData)
                    .then((response) => {
                        if (response.data.hasOwnProperty('redirect')) {
                            document.location = response.data.redirect;
                        }
                    })
                    .catch((error) => {
                        if (error.response.hasOwnProperty('data')) {
                            this.errors = error.response.data.errors;
                        }
                    });
            },
            async fetchData() {
                await axios
                    .post('/subscription/init', {locale: this.locale})
                    .then((response) => {
                        if (response.data.hasOwnProperty('groups')) {
                            const groups = response.data.groups;

                            if (groups.length) {
                                for (let g in groups) {
                                    for (let o in groups[g].options) {
                                        groups[g].options[o].selected = false;
                                    }

                                    let optionFound = false;

                                    if (this.group && this.option) {
                                        if (this.group == groups[g].type) {
                                            this.selectedGroup = g;

                                            for (let o in groups[g].options) {
                                                if (groups[g].options[o].type == this.option) {
                                                    groups[g].options[o].selected = true;
                                                    optionFound = true;
                                                    break;
                                                }
                                            }
                                        }
                                    }

                                    if (!optionFound){
                                        for (let o in groups[g].options) {
                                            if (groups[g].options[o].popular) {
                                                groups[g].options[o].selected = true;
                                                optionFound = true;
                                                break;
                                            }
                                        }
                                    }

                                    if (!optionFound){
                                        if (groups[g].options.length) {
                                            groups[g].options[0].selected = true;
                                        }
                                    }
                                }
                            }

                            this.groups = groups;
                        }

                        if (response.data.hasOwnProperty('countries')) {
                            this.countries = response.data.countries;
                        }
                        if (response.data.hasOwnProperty('contactPageUrl')) {
                            this.contactPageUrl = response.data.contactPageUrl;
                        }
                        if (response.data.hasOwnProperty('loggedIn')) {
                            this.loggedIn = response.data.loggedIn;
                        }
                        if (response.data.hasOwnProperty('termsLinkTitle')) {
                            this.termsLinkTitle = response.data.termsLinkTitle;
                        }
                        if (response.data.hasOwnProperty('quoteButtonTitle')) {
                            this.quoteButtonTitle = response.data.quoteButtonTitle;
                        }

                        if (this.loggedIn) {
                            if (response.data.hasOwnProperty('canChangeSubscription')) {
                                this.canChangeSubscription = response.data.canChangeSubscription;
                            }
                            if (response.data.hasOwnProperty('canChangeSubscriptionDate')) {
                                this.canChangeSubscriptionDate = response.data.canChangeSubscriptionDate;
                            }
                            if (response.data.hasOwnProperty('canPauseSubscription')) {
                                this.canPauseSubscription = response.data.canPauseSubscription;
                            }
                            if (response.data.hasOwnProperty('subscriptionIsPausedUntil')) {
                                this.subscriptionIsPausedUntil = response.data.subscriptionIsPausedUntil;
                            }
                            if (response.data.hasOwnProperty('subscriptionIsCanceled')) {
                                this.subscriptionIsCanceled = response.data.subscriptionIsCanceled;
                            }
                        }
                    })
                    .catch(() => {

                    });

                this.initialized = true;

                if (!this.loggedIn) {
                    this.currentGroupType = null;
                    this.currentOptionType = null;
                    this.currentGroupIndex = null;
                    this.currentOptionIndex = null;
                } else if (this.currentGroupType) {
                    for (let g in this.groups) {
                        if (this.groups[g].type == this.currentGroupType) {
                            this.currentGroupIndex = g;

                            for (let o in this.groups[g].options) {
                                if (this.groups[g].options[o].type == this.currentOptionType) {
                                    this.currentOptionIndex = o;
                                    break;
                                }
                            }

                            break;
                        }
                    }
                }
            }
        },
        computed: {
            isCurrentSubscription() {
                return this.currentGroupIndex == this.selectedGroup && this.currentOptionType == this.selectedSubscriptionOptionType;
            },
             selectedSubscriptionOptionIndex() {
                for (let o in this.groups[this.selectedGroup].options) {
                    if (this.groups[this.selectedGroup].options[o].selected) {
                        return o;
                    }
                }

                return '';
            },
            selectedSubscriptionOptionType() {
                for (let o in this.groups[this.selectedGroup].options) {
                    if (this.groups[this.selectedGroup].options[o].selected) {
                        return this.groups[this.selectedGroup].options[o].type;
                    }
                }

                return '';
            },
            selectedSubscriptionOptionPrice() {
                for (let o in this.groups[this.selectedGroup].options) {
                    if (this.groups[this.selectedGroup].options[o].selected) {
                        return this.groups[this.selectedGroup].options[o].price;
                    }
                }

                return '';
            },
            selectedSubscriptionOptionVat() {
                return this.selectedSubscriptionOptionPrice*0.21;
            },
            selectedSubscriptionOptionCredits() {
                for (let o in this.groups[this.selectedGroup].options) {
                    if (this.groups[this.selectedGroup].options[o].selected) {
                        return this.groups[this.selectedGroup].options[o].credits;
                    }
                }

                return '';
            },
            selectedSubscriptionName() {
                let name = this.groups[this.selectedGroup].name;

                for (let o in this.groups[this.selectedGroup].options) {
                    if (this.groups[this.selectedGroup].options[o].selected) {
                        name += ' - ' + this.groups[this.selectedGroup].options[o].name;
                        break;
                    }
                }

                return name;
            }
        },
        async mounted() {
            this.currentGroupType = this.currentGroup;
            this.currentOptionType = this.currentOption;
            this.fetchData();
        },
    }
</script>
